import React from 'react';

import { Accordion, Box, HStack, IconButton, VStack } from '@chakra-ui/react';
import { HardwareQueue } from '../../apiClient/types';
import { BackButton } from '../../layout/BackButton';
import { PageHeading } from '../../layout/PageHeading';
import { RepeatIcon } from '@chakra-ui/icons';
import { QueueDetailItem } from './QueueDetailItem';
import { FormattedMessage, useIntl } from 'react-intl';

type Props = {
  queues: HardwareQueue[];
  refresh: () => Promise<void>;
  isLoading: boolean;
};

export const QueuePageContent = ({ queues, refresh, isLoading }: Props) => {
  const intl = useIntl();

  return (
    <HStack justify="space-between">
      <VStack align="top" w="full">
        <HStack>
          <PageHeading
            heading={<FormattedMessage id="queue_heading" />}
            description={<FormattedMessage id="queue_description" />}
          />
          <IconButton
            isRound
            isLoading={isLoading}
            variant="ghost"
            onClick={refresh}
            icon={<RepeatIcon />}
            aria-label={intl.formatMessage({ id: 'commons_refresh' })}
          />
        </HStack>
        <HStack pt={2} align="start">
          <BackButton />
        </HStack>
        <Box background={'white'}>
          <Accordion allowToggle w="full" allowMultiple>
            {queues.map((queue) => (
              <QueueDetailItem
                key={queue.id}
                queue={queue}
                hardware={queue.hardware}
                refresh={refresh}
              />
            ))}
          </Accordion>
        </Box>
      </VStack>
    </HStack>
  );
};
